"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
var React = require("react");
var variables_1 = require("../../assets/variables");
var Button_style_1 = require("./Button.style");
var Icon_1 = require("../Icon");
exports.Button = function (props) {
    var defaultProps = {
        colorPrimary: props.colorPrimary ? props.colorPrimary : variables_1.colors.primary,
        colorSecondary: props.colorSecondary ? props.colorSecondary : variables_1.colors.baseLight,
    };
    if (props.href) {
        var LinkAppearance = Button_style_1.default.Default.withComponent('a');
        return (React.createElement(LinkAppearance, __assign({}, props, defaultProps, { target: "_blank" }), props.children ? props.children : 'Link'));
    }
    var ButtonAppearance = Button_style_1.default.Default;
    return (React.createElement(ButtonAppearance, __assign({}, props, { type: props.type || 'button' }, defaultProps),
        props.children ? props.children : 'Button',
        ' ',
        props.icon ? (React.createElement(Button_style_1.default.IconWrap, null,
            React.createElement(Icon_1.default, { icon: props.icon, size: 18 }))) : null));
};
exports.default = exports.Button;
//# sourceMappingURL=Button.js.map